import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageLayout from "../../component/PageLayout";
import IconAddLocation from "../../component/SvgIcon/IconAddLocation";
import IconLocation from "../../component/SvgIcon/IconLocation";
import api from "../../services"; // make sure your api service is correct
import { useSwal } from "../../services/SweetAlert";

export default function AddLocation() {
  const alert = useSwal();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Country: "",
    Latitude: "",
    Longitude: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simple validation
    if (!formData.Name || !formData.Country || !formData.Latitude || !formData.Longitude) {
      alert("error", "All fields are required");
      setLoading(false);
      return;
    }

    try {
      const res = await api.post("/AddCompany_locations", formData);
      if (res.data.success) {
        alert("success", "Location added successfully!");
        navigate("/location-list"); // redirect to location list
      } else {
        alert("error", res.data.message || "Failed to add location");
      }
    } catch (error) {
      console.error("Add location failed:", error);
      alert("error", "Failed to add location");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout
      url="/location-list"
      secondiconTitle="Location List"
      secondicon={<IconLocation />}
      icon={<IconAddLocation />}
      pagetitle="Add Location"
    >
      <div className="topspace">
        <div className="container-fluid">
          <section className="user-section mb-4">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>
                    Location Name <small>*</small>
                  </label>
                  <input
                    type="text"
                    name="Name"
                    required
                    className="form-control"
                    value={formData.Name}
                    onChange={handleChange}
                    placeholder="Enter Location Name"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Country Name <small>*</small>
                  </label>
                  <input
                    type="text"
                    name="Country"
                    required
                    className="form-control"
                    value={formData.Country}
                    onChange={handleChange}
                    placeholder="Enter Country Name"
                  />
                </div>

                <div className="form-group d-flex flex-row gap-3">
                  <div className="latitudeno d-flex flex-column gap-2 w-50">
                    <label>
                      Latitude Number <small>*</small>
                    </label>
                    <input
                      type="text"
                      name="Latitude"
                      required
                      className="form-control"
                      value={formData.Latitude}
                      onChange={handleChange}
                      placeholder="Enter Latitude Number"
                    />
                  </div>

                  <div className="latitudeno d-flex flex-column gap-2 w-50">
                    <label>
                      Longitude Number <small>*</small>
                    </label>
                    <input
                      type="text"
                      name="Longitude"
                      required
                      className="form-control"
                      value={formData.Longitude}
                      onChange={handleChange}
                      placeholder="Enter Longitude Number"
                    />
                  </div>
                </div>
              </div>

              <div className="bottombtn w-100 justify-content-center d-flex gap-3 mt-4">
                <Link to="/location-list" className="btn backbtn">
                  Back
                </Link>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Adding..." : "Add Location"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}
